module.exports = __webpack_public_path__ + "static/media/ValidandoTelefonia.a501f756.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Images/ValidandoTelefonia/ValidandoTelefonia.gif
// module id = 2601
// module chunks = 0